import React from "react";
import { Button, Form, Loader, SubmitButton } from "@culturehq/components";
import { StoryQuestion } from "chq";
import { Trans } from "app/utils";
import { MagicWandIcon } from "components/common/icons";
import magicWandIcon from "images/magic-wand_gradient.svg";
import { SaveButton } from "./AIStoryQuestionModalForm";
import styles from "./newAIStoryQuestionModal.module.scss";

const TextareaFieldPlaceholder: React.FC<{}> = () => (
  <div className="FormFieldPlaceholder">
    <p className="FormFieldPlaceholder__title" />
    <p className="FormFieldPlaceholder__textarea" />
  </div>
);

const StringFieldPlaceholder: React.FC<{}> = () => (
  <div className="FormFieldPlaceholder">
    <p className="FormFieldPlaceholder__title" />
    <p className="FormFieldPlaceholder__text" />
  </div>
);

const SelectFieldPlaceholder: React.FC<{}> = () => (
  <div className="FormFieldPlaceholder">
    <p className="FormFieldPlaceholder__select" />
  </div>
);

interface AIStoryQuestionLoadingFormProps {
  promptDescription: string;
  storyQuestion?: StoryQuestion;
}

const AIStoryQuestionLoadingForm: React.FC<AIStoryQuestionLoadingFormProps> = ({
  promptDescription, storyQuestion
}) => (
  <Form onSubmit={() => {}}>
    <Loader loading />
    <div className={styles["prompt-header"]}>
      <div className={styles["prompt-header__info"]}>
        <div className={styles["prompt-header__info-icon"]}>
          <img style={{ width: "24px", height: "24px" }} src={magicWandIcon} alt="Magic Wand" />
        </div>
        <div className={styles["prompt-description"]}>
          <span className="chq-ffd--lb"><Trans>What are you looking to do?</Trans></span>
          <p>{promptDescription}</p>
        </div>
      </div>
      <div className="generate-again">
        <Button
          className={styles["generate-again__button"]}
          disabled
          inverted
          onClick={() => {}}
        >
          <MagicWandIcon /> <Trans>Generate again</Trans>
        </Button>
      </div>
    </div>
    <hr className={styles.divider} />
    <TextareaFieldPlaceholder />
    <SelectFieldPlaceholder />
    <SelectFieldPlaceholder />
    <SelectFieldPlaceholder />
    <StringFieldPlaceholder />
    <StringFieldPlaceholder />
    <SubmitButton primary>
      {_submitting => <SaveButton storyQuestion={storyQuestion} />}
    </SubmitButton>
  </Form>
);

export default AIStoryQuestionLoadingForm;
